import common from '../../../../common';
export default common.directives.transferDom;
